/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * Make sure this isn't imported in the analytics worker
 *	> 'owa-local-storage' import is restricted from being used. localStorage is not available in the analytics worker [analytics-worker-lint] */
import { getItem } from 'owa-local-storage';
import type { SessionData } from 'owa-service/lib/types/SessionData';
import type WebSessionType from 'owa-service/lib/contract/WebSessionType';

interface SessionDiagnostics {
    puid?: string;
    tid?: string;
    mbx?: string;
    prem?: string;
    isCon?: boolean;
    upn?: string;
}

let diagnostics: SessionDiagnostics;
export function getSessionDiagnostics(): SessionDiagnostics {
    if (!diagnostics) {
        const cachedDiagnosticsString = getItem(self, 'BootDiagnostics');
        if (cachedDiagnosticsString) {
            try {
                diagnostics = JSON.parse(cachedDiagnosticsString);
            } catch {
                diagnostics = {};
            }
        } else {
            diagnostics = {};
        }
    }

    return diagnostics;
}

export function updateDiagnosticsOnSessionData(settings: SessionData) {
    const sessionSettings = settings.owaUserConfig?.SessionSettings;
    if (sessionSettings) {
        diagnostics = {
            puid: sessionSettings.UserPuid,
            tid: sessionSettings.ExternalDirectoryTenantGuid,
            mbx: sessionSettings.MailboxGuid,
            prem: sessionSettings.IsPremiumConsumerMailbox ? '1' : '0',
            isCon: sessionSettings.WebSessionType != 0,
            upn: sessionSettings.UserPrincipalName,
        };
    }

    return diagnostics;
}

export function getPuid(): string | undefined {
    return getSessionDiagnostics().puid;
}

export function getTenantGuid(): string | undefined {
    return getSessionDiagnostics().tid;
}

export function getMailboxGuid(): string | undefined {
    return getSessionDiagnostics().mbx;
}

export function getPremiumUser(): string | undefined {
    return getSessionDiagnostics().prem;
}

export function isConsumer(): boolean | undefined {
    return getSessionDiagnostics().isCon;
}

export function getUserUpn(): string | undefined {
    return getSessionDiagnostics().upn;
}
